export default "__VITE_ASSET__D3b_55lr__"